// ============================================================
// Staff Discipline API — Staff Management
// ============================================================

import client from './axios';

export const staffDisciplineApi = {
  getStatusEnums: async () => {
    const response = await client.get('/staff-discipline/status-enums');
    return response.data;
  },

  getDisciplineHistory: async (staffId, schoolId) => {
    const response = await client.get(`/staff-discipline/${staffId}/discipline`, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  updateDiscipline: async (staffId, schoolId, payload) => {
    const response = await client.post(
      `/staff-discipline/${staffId}/discipline?school_id=${schoolId}`,
      payload
    );
    return response.data;
  },
};
